import React from "react";
import { calculateBarWidth } from "../../utils";
import useTranslationHook from "hooks/useTranslationHook";
import styles from "./categoryRatingBar.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface CategoryRatingBarProps {
  label: string;
  labelKey?: string;
  score: number;
  maxScore?: number;
  animate?: boolean;
  compact?: boolean;
}

const CategoryRatingBar: React.FC<CategoryRatingBarProps> = ({
  label,
  labelKey,
  score,
  maxScore = 5,
  animate,
  compact = false,
}) => {
  const { t } = useTranslationHook();
  const fillWidth = calculateBarWidth(score, maxScore);
  // If animate is not explicitly passed, show bars at full width (no animation)
  const shouldAnimate = animate !== undefined;
  const showFill = !shouldAnimate || animate;

  const displayLabel = labelKey ? t(labelKey) || label : label;

  return (
    <div className={`${styles.container}${compact ? ` ${styles.compact}` : ""}`}>
      <div className={styles.labelRow}>
        <span className={styles.label}>{displayLabel}</span>
        <span className={styles.score}>{score}</span>
      </div>
      <div className={styles.track}>
        <div
          className={`${styles.fill}${shouldAnimate && animate ? ` ${styles.animated}` : ""}`}
          style={{ width: showFill ? fillWidth : "0%" }}
        />
      </div>
    </div>
  );
};

export default wrapperHOC(CategoryRatingBar, {
  componentName: "CategoryRatingBar",
  showForChina: true,
});
